import moment from 'moment'
import Languages from '../../../../utils/Languages.js'
import {Shift} from '../../shifts/shifts.types.js'
import {Reseller} from '../../resellers/resellers.types.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {button, card, field, mailDocument, stack} from './mailLayout.js'

type Point = Shift['startPoint']

const location = (point: Point) => point ? `${point.street} ${point.nr}${point.addition || ''}, ${point.postalCode}, ${point.city}` : ''

const template = ({
    logo,
    color = '',
    shift,
    messengerName,
    customerName,
    branchName = '',
    buttonText = Languages.mailOpenShift.NL,
    reseller,
    noButtonClick = false
}: {
    logo?: string
    color?: string
    shift: Shift
    messengerName: string
    customerName: string
    branchName?: string
    buttonText?: string
    reseller: Reseller
    noButtonClick?: boolean
}, baseUrl?: string) => {
    const hostUrl = typeof process !== 'undefined' ? process.env?.HOST_URL : undefined
    const nodeEnv = typeof process !== 'undefined' ? process.env?.NODE_ENV : undefined

    const domain = (reseller?.customBrandingEnabled && reseller?.settings.domain) ? `https://${reseller.settings.domain}` : (hostUrl || (nodeEnv === 'production' ? 'https://app.veloyd.nl' : 'https://test.veloyd.nl'))

    return mailDocument({
        logo,
        color: color || '#ff751a',
        baseUrl,
        content: stack([
            card([
                field(Languages.mailShiftName.NL, shift.name),
                field(Languages.date.NL, shift.date ? moment(shift.date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''),
                field(Languages.branch.NL, branchName),
                field(Languages.messenger.NL, messengerName),
                field(Languages.customer.NL, customerName),
                field(Languages.startTime.NL, shift.plannedStartTime),
                field(Languages.startLocation.NL, location(shift.startPoint)),
                field(Languages.endTime.NL, shift.plannedEndTime),
                field(Languages.endLocation.NL, location(shift.endPoint)),
                field(Languages.reference.NL, shift.reference),
                field(Languages.instructions.NL, shift.instructions),
                button(buttonText, noButtonClick ? null : `${domain}/diensten/${shift._id}`, color || '#ff751a')
            ])
        ])
    })
}

export default escapedTemplate(template)
